import { ProductAvailabilityData } from '@/data/types/ProductAvailabilityData';
import { useEffect, useRef, useState } from 'react';

export const useStock = (availability?: ProductAvailabilityData[]) => {
	const [someWstock, setSomeWstock] = useState<boolean | undefined>(undefined);
	const initialAvailability = useRef<ProductAvailabilityData[] | null>(null);

	useEffect(() => {
		const resolvedAvailability = availability ?? [];
		if (!initialAvailability.current && resolvedAvailability.length > 0) {
			initialAvailability.current = resolvedAvailability;
		}

		if (initialAvailability.current) {
			setSomeWstock(initialAvailability.current.some((av) => av.status === true));
		} else {
			setSomeWstock(false);
		}
	}, [availability]);

	return { someWstock, initialAvailability };
};
